import React from "react";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { FiArrowRight } from "react-icons/fi";
import { seekhoLinkedinJobsLink } from "../../utils/constants";
import { handleJoinOurTeamClickEvent } from "../../utils/helperEventFunctions";

const JoinOurTeam = ({
  ctaClassName,
  arrowClass,
  desktopStatus,
  mobileStatus,
}) => {
  const router = useRouter();
  const firebaseUID = useSelector((state) => state.currentUser.firebaseUID);
  const sourceScreen = router?.query ? router?.asPath : router?.pathname;

  const handleJoinOurTeamClicked = () => {
    // event trigger for Join Our Team CTA
    handleJoinOurTeamClickEvent({
      firebaseUID,
      desktopStatus,
      mobileStatus,
      sourceScreen,
      anonymousId: "",
    });
  };
  return (
    <div className="relative">
      <a href={seekhoLinkedinJobsLink} target="_blank" rel="noreferrer">
        <button
          onClick={handleJoinOurTeamClicked}
          className={`relative z-20 !text-[14px] shiny-button !font-lexend bg-gradient-to-r from-[#AF30BF] to-[#5E30BF] w-fit !py-3 text-white flex items-center justify-center gap-x-2 font-medium !border !border-[#bd7ed1] rounded-lg ${
            ctaClassName || ""
          }`}
        >
          Join Our Team
          <FiArrowRight className={` ${arrowClass || ""} text-[18px]`} />
        </button>
      </a>
    </div>
  );
};

export default JoinOurTeam;
